import "./SourcePreview.css";

interface Props {
    author: string;
}

export const SourcePreviewAuthor = ({ author }: Props) => {
    return <p className="wai-source-card-author">{author}</p>;
};
